// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-spinner {
  margin: 32px;
  height: 72px;
  width: 72px;
}

.payment-input {
  margin: 6px 12px;
  background: var(--payment-modal-item-background, white);
  border-radius: 5px;
  padding: var(--ion-margin);
  color: var(--ion-color-black);
}

.header-msg {
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
}

.payment-method-row {
  min-height: 56px;
  align-items: center;
  margin: 6px 12px;
  background: white;
  border-radius: 5px;
}
.payment-method-row > ion-col {
  padding: 0;
}
.payment-method-row > ion-col ion-item {
  overflow: hidden;
  --background: #00000000;
}
.payment-method-row > ion-col ion-item > ion-radio {
  --color: var(--ion-color-primary);
  --color-checked: var(--ion-color-primary);
  margin: 11px 16px 10px 4px;
}
.payment-method-row > ion-col ion-item > ion-label {
  color: var(--ion-color-black);
  font-weight: bold;
}

.back-icon {
  margin-right: 10px;
  width: 30px;
}

.bottom-end {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 300px;
  width: 142px;
}

.padding-5 {
  padding: 5px;
}

ion-content {
  --background: #F9F9F9;
}

.icon-size {
  margin: 0px;
  zoom: var(--payment-icon-size);
}
.icon-size.google_pay {
  width: 50px;
  display: inline-grid;
  position: absolute;
  right: 0;
}
.icon-size.apple_pay {
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/smoothr-web-app-core/components/payment-modal/payment-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,uDAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;AACF;;AAEA;EACE,eAAA;EACA,oCAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;AACE;EACE,UAAA;AACJ;AACI;EACE,gBAAA;EACA,uBAAA;AACN;AACM;EACE,iCAAA;EACA,yCAAA;EACA,0BAAA;AACR;AAEM;EACE,6BAAA;EACA,iBAAA;AAAR;;AAQA;EACE,kBAAA;EACA,WAAA;AALF;;AAQA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,WAAA;EACA,8BAAA;AALF;AAMI;EACE,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;AAJN;AAMI;EACE,WAAA;AAJN","sourcesContent":["ion-spinner {\n  margin: 32px;\n  height: 72px;\n  width: 72px;\n}\n\n.payment-input {\n  margin: 6px 12px;\n  background: var(--payment-modal-item-background, white);\n  border-radius: 5px;\n  padding: var(--ion-margin);\n  color: var(--ion-color-black);\n}\n\n.header-msg {\n  font-size: 18px;\n  font-family: AppFontBold, sans-serif;\n}\n\n.payment-method-row {\n  min-height: 56px;\n  align-items: center;\n  margin: 6px 12px;\n  background: white;\n  border-radius: 5px;\n\n  > ion-col {\n    padding: 0;\n\n    ion-item {\n      overflow: hidden;\n      --background: #00000000;\n\n      > ion-radio {\n        --color: var(--ion-color-primary);\n        --color-checked: var(--ion-color-primary);\n        margin: 11px 16px 10px 4px;\n      }\n\n      > ion-label {\n        color: var(--ion-color-black);\n        font-weight: bold;\n      }\n    }\n\n\n  }\n}\n\n.back-icon {\n  margin-right: 10px;\n  width: 30px;\n}\n\n.bottom-end {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 300px;\n  width: 142px;\n}\n\n.padding-5 {\n  padding: 5px;\n}\n\nion-content {\n  --background: #F9F9F9;\n}\n\n.icon-size {\n  margin: 0px;\n  zoom: var(--payment-icon-size);\n    &.google_pay {\n      width: 50px;\n      display: inline-grid;\n      position: absolute;\n      right: 0;\n    }\n    &.apple_pay {\n      color:#000;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
